import React from 'react';
import styled from 'styled-components';
import Icon from '../Icon';
import { Text } from '../Typography';
import { ParsedDetailsResult } from '../AddressSearch/PlacesService';
import theme from '../theme';

interface AddressComponentProps {
  address: ParsedDetailsResult | string;
  displayIcon?: boolean;
}

const AddressComponent: React.FC<AddressComponentProps> = props => {
  const { address, displayIcon = true } = props;

  const parseAddressString = (addressString: string): ParsedDetailsResult => ({
      city: '',
      postalCode: '',
      province: '',
      line1: addressString,
      line2: '',
    });

  const _address =
    typeof address === 'object' ? address : parseAddressString(address);

  const mainText = `${_address.line1}`;

  const subText = `${_address.city ? `${_address.city}, ` : ''}${
    _address.province ? `${_address.province} ` : ''
  }${_address.postalCode}`.trim();

  return (
    <Container>
      {displayIcon && <GoogleMapsIcon />}
      <TextContainer>
        <MainText>{mainText}</MainText>
        <SubText>{subText}</SubText>
      </TextContainer>
    </Container>
  );
};

const Container = styled.div`
  display: flex;
  flex: 1;
`;

const TextContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex: 4;
`;

const MainText = styled(Text)`
  color: ${theme.gray8};
`;

const SubText = styled(Text)`
  font-size: 12px;
  line-height: 20px;
  color: ${theme.gray7};
`;

const GoogleMapsIcon = styled(Icon).attrs({ type: 'marker' })`
  flex: 1;
`;

export default AddressComponent;
